import "../css/levelUpModal.css";

export const LevelUpImage = ({ level }) => {
  const getImage = () => {
    if (level < 10) {
      return "/images/level-up-images/level-up-image-1.png";
    } else {
      return "/images/level-up-images/level-up-image-2.png";
    }
  };
  return (
    <div
      className={`level-up-image-container-${level < 10 ? "blue" : "golden"}`}
    >
      <img
        src={getImage()}
        alt={`Level ${level}`}
        className="level-up-main-image"
        onError={(e) => {
          e.target.src = "/images/level-up-images/level-up-image-1.webp";
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "90%",
          left: "50%",
        }}
      >
        <div
          style={{
            position: "absolute",
            transform: "translate(-50%, -50%)",
            color:
              level < 10
                ? "rgba(214, 236, 255, 1)" // Existing text color
                : "rgba(255, 253, 190, 1)", // Existing text color
            fontWeight: 900,
            fontSize: "clamp(30px, 10vw, 60px)",
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            textAlign: "center",
            // 👇 NEW: Conditional Text Shadow for the Glow Effect
            textShadow:
              level < 10
                ? "0 0 50px rgba(0, 140, 255, 0.9), 0 0 100px rgba(0, 140, 255, 0.6)"
                : "0 0 50px rgba(255, 253, 190, 0.9), 0 0 100px rgba(255, 253, 190, 0.6)",
          }}
        >
          {level}
        </div>
      </div>
    </div>
  );
};
